<template>
  <span>
    <button
      class="button is-rounded is-small is-light tag-button"
      @click="$emit('open-cashback-modal')"
    >
      <span class="money-icon">💵</span>

      <span v-if="cashbacks.length === 1 && cashbacks[0].type === 'general'">
        &nbsp;&nbsp;
        {{ `${$t("dashboard.cashback")} ${cashbacks[0].percentage}%` }}
      </span>

      <span
        v-else-if="cashbacks.length === 1 && cashbacks[0].type === 'category'"
      >
        &nbsp;&nbsp;
        {{
          `${$t("dashboard.cashback")} ${cashbacks[0].percentage}% (${$t(
            "settings.cashbackTypeCategory"
          )})`
        }}
      </span>

      <span
        v-else-if="
          cashbacks.length === 1 && cashbacks[0].type === 'subcategory'
        "
      >
        &nbsp;&nbsp;
        {{
          `${$t("dashboard.cashback")} ${cashbacks[0].percentage}% (${$t(
            "settings.cashbackTypeSubcategory"
          )})`
        }}
      </span>

      <span
        v-else-if="cashbacks.length === 1 && cashbacks[0].type === 'product'"
      >
        &nbsp;&nbsp;
        {{
          `${$t("dashboard.cashback")} ${cashbacks[0].percentage}% (${$t(
            "settings.cashbackProduct"
          )})`
        }}
      </span>

      <span v-else-if="cashbacks.length > 1">
        &nbsp;&nbsp;
        {{
          `${$t("dashboard.cashbackUpTo")} ${Math.max(
            ...cashbacks.map(c => {
              return c.percentage;
            })
          )}%`
        }}
      </span>
    </button>
    &nbsp;
  </span>
</template>

<script>
export default {
  props: ["cashbacks"]
};
</script>

<style scoped>
.tag-button {
  cursor: pointer;
  border: 1px solid #bbbbbb;
}
</style>
